import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Link,
  Stack,
  Typography,
} from "@mui/material";
import Box from "@mui/material/Box";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { KeyboardShortcutGrid } from "../components/Account/KeyboardShortcutGrid";
import { AlertDialog } from "../components/AlertDialog";
import { LockableButton } from "../components/LockableButton";
import { PageLayout } from "../components/PageLayout";
import { SignOutButton } from "../components/SignOutButton";
import {
  defaultKeyboardShortcuts,
  useUpdateKeyboardShortcuts,
} from "../requests/keyboardShortcuts";
import { UserPermission } from "../requests/users";
import { Users } from "./Users";

export const Account = () => {
  const navigate = useNavigate();

  const updateKeyboardShortcuts = useUpdateKeyboardShortcuts();
  const resetKeyboardShortcuts = () => {
    updateKeyboardShortcuts
      .mutateAsync(defaultKeyboardShortcuts)
      // TODO: forced reload isn't ideal, but it's working. Otherwise, the table doesn't re-render.
      .then(() => window.location.reload());
  };
  const [resetKeyboardShortcutsDialog, setResetKeyboardShortcutsDialog] = useState(false);

  const resetKeyboardShortcutsButton = (
    <LockableButton
      color="error"
      variant="contained"
      onClick={() => {
        setResetKeyboardShortcutsDialog(true);
      }}
      minUserPermission={UserPermission.read}
    >
      Reset Shortcuts to Default
    </LockableButton>
  );

  return (
    <PageLayout
      title="Account"
      subtitle="Manage your subscription, users, and keyboard shortcuts."
      maxWidth="xl"
      showPaper={false}
    >
      <Box sx={{ mb: 4 }}>
        <Stack direction="row" spacing={2}>
          <LockableButton
            onClick={() => navigate("/subscription")}
            variant="outlined"
            minUserPermission={UserPermission.owner}
          >
            Change Subscription
          </LockableButton>
          <SignOutButton variant="outlined" />
        </Stack>
      </Box>

      <AlertDialog
        message="Reset your keyboard shortcuts?"
        isOpen={resetKeyboardShortcutsDialog}
        onCloseDialog={() => setResetKeyboardShortcutsDialog(false)}
        onConfirmDialog={resetKeyboardShortcuts}
        confirmText="Reset"
      />

      <Stack spacing={2} sx={{ mb: 4 }}>
        <Accordion defaultExpanded={false}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="keyboard-shortcuts-content"
            id="keyboard-shortcuts-header"
          >
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              Personal Keyboard Shortcuts
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <KeyboardShortcutGrid resetButton={resetKeyboardShortcutsButton} />
          </AccordionDetails>
        </Accordion>

        <Accordion defaultExpanded={false}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="users-content"
            id="users-header"
          >
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              Users
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Users />
          </AccordionDetails>
        </Accordion>

        <Accordion expanded>
          <AccordionSummary aria-controls="contact-content" id="contact-header">
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              Contact QuickTap
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography variant="body1" sx={{ mb: 3 }}>
              Have feedback, questions, or bug reports? We'd love to hear from you!
            </Typography>
            <Typography variant="body1">
              Email us at <Link href="mailto:support@getquicktap.com">support@getquicktap.com</Link>{" "}
              and we'll get back to you as soon as possible.
            </Typography>
          </AccordionDetails>
        </Accordion>
      </Stack>
    </PageLayout>
  );
};
